<template>
  <div class="engine-data-custom-report">
    <div id="container">
      <div class="incremental-search-container">
        <incremental-search
          :autoFocus="true"
          ref="incrementalSearch"
          :data="searchResult"
          :icon="null"
          placeholder="タグIDもしくは項目名を入力"
          @input="searchQueryUpdate"
          @selected="addCustomChannelId"
          :hideGroupTitle="true"
          :searchLimit="10"
          class="channel-incremental-search aisea-text-14-400-black h-12"
        >
          <template v-slot:channels="{ suggestion }">
            <div class="flex items-center justify-between h-5">
              <div class="flex items-center">
                <div class="suggestion-row mt-1">
                  <span class="mb-1 suggestion-id aisea-text-14-400-black">
                    {{ suggestion.id }}
                  </span>
                  <span class="mb-1 suggestion-name aisea-text-14-400-black">
                    {{ suggestion.name }}
                  </span>
                  <span class="mb-1 suggestion-unit aisea-text-14-400-black">
                    <template v-if="suggestion.unit">
                      {{ "[" + suggestion.unit + "]" }}
                    </template>
                  </span>
                </div>
              </div>
              <div class="suggestion-action aisea-text-14-400-black hidden">追加</div>
            </div>
          </template>
          <!-- No Items Slot -->
          <template v-slot:noResult="{}">
            <div class="flex items-center">
              <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" class="mr-4" />
              <span>見つかりませんでした</span>
            </div>
          </template>
        </incremental-search>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import IncrementalSearch from "@/components/incremental-search/incrementalSearch.vue";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapGetters, mapActions } = createNamespacedHelpers("enterpriseVesselMonitoringEngine");
import { DeviceInfoMixin } from "@/mixins";

export default {
  name: "inputSearchCustomReport",
  components: {
    IncrementalSearch,
  },
  mixins: [DeviceInfoMixin],
  data() {
    return {
      searchResult: {},
    }
  },
  computed: {
    ...mapState({
      engineInfo: state => state.engineInfo,
    }),
    ...mapGetters(["getCustomChannelIds"]),
  },
  methods: {
    ...mapActions(["searchChannels", "setCustomChannelIdsState", ]),
    async searchQueryUpdate(query) {

      let keyword = query.trim();
      if (keyword.length !== 0) {
        let kind = Object.keys(this.engineInfo.version)[0];
        let payload = {
          vessel_id: this.engineInfo.vessel_info.id,
          params: {
            version_id: this.engineInfo.version[kind].version_id,
            keyword: keyword,
            limit: 10,
          }
        };
        this.searchResult = await this.searchChannels(payload);
        this.$nextTick(() => {
          this.$refs.incrementalSearch.updateSuggestionsList();
        })
      }
    },
    async addCustomChannelId(val) {
      if (!this.getCustomChannelIds.includes(val.channels.id)) {
        let newChannelIds = [...this.getCustomChannelIds, val.channels.id];
        // NOTE: カスタムチャンネル保存実行箇所
        await this.setCustomChannelIdsState(newChannelIds);
        this.searchResult = {};
        this.$nextTick(() => {
          this.$refs.incrementalSearch.updateSuggestionsList();
        })
        this.$emit("refreshChannelData"); 
        this.$vs.notify({
          title: "カスタムレポート設定",
          text: `${val.channels.name}をカスタムレポートに追加しました。`,
          iconPack: "feather",
          icon: "icon-check",
          color: "success",
        });
      } else {
        Vue.$log.info("this id has been already added");
      }
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

.engine-data-custom-report {
  width: 100%;
  .incremental-search-container {
    display: flex;
    align-items: center;
  }
  .input-title-text {
    height: 20px;
    margin-left: 0;
    margin-right: 0;
    padding: 0;
    width: 3rem;
    word-break: normal;
    word-wrap: normal; 
  }

  .channel-incremental-search {

    width: 100%;
    .isFocus {
      i {
        color: $aisea-blue !important;
      }
    }
    input {
      font-size: 16px !important;
      color: #333333 !important;

      background: $aisea-white !important;
      border: 1px solid $aisea-light-gray !important;
      padding-left: 0;
    }
    .vs-inputx.vs-input--input.normal.hasValue.hasIcon {
      font-size: 16px !important;
      color: #333333 !important;

      background: $aisea-white !important;
      border: 1px solid $aisea-white !important;
      padding-left: 0;
    }
    .vs-input--placeholder {
      color: $aisea-gray !important;
      font-size: 12px;
    }
    .auto-suggest-suggestions-list {
      width: 310px;
      background: $aisea-pure-white;
      span {
        color: #333333;
      }
      .suggestion-action {
        color: $aisea-blue;
      }
    }
  }
  // .auto-suggest-suggestions-list {
  //   color: $aisea-blue-gray;
  //   background: $aisea-white !important;
  //   white-space: nowrap;
  //   width: auto;
  // }
  // .auto-suggest__suggestion-group__suggestion {
  //   padding: 4px 10px 7px 10px;
  //   font-size: 16px;
  // }

  .suuggestion-row {
    height: 1.2rem;
  }
  .suggestion-id {
    margin-right: 6px;
  }
  .suggestion-name {
    display:inline-block;
    vertical-align: middle;
    margin-right: 6px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 140px;
  }
  .vx-auto-suggest__current-selected {
    span {
      color: #f8f8f8 !important;
    }
    .suggestion-action {
      color: #f8f8f8 !important;
      display: block;
    }
  }
}
</style>
